"use strict"

import React from "react"

import { grey_color, black_color, getLabelTranslationFactor } from "./utils"
import { withFontSizeConfig } from "../../../config/FontSizeConfigProvider"

const XAxis = ({
  x,
  height,
  width,
  gridlines,
  label,
  axisTitleFontSize,
  tickFontSize,
  suppAxisTitleFontSize,
  suppTickFontSize,
  isSuppPlot,
  formatter = (time) => time.toString(),
}) => {
  const [scaledFontSize, scaledTickSize, translate_factor] = getLabelTranslationFactor(
    isSuppPlot ? suppAxisTitleFontSize : axisTitleFontSize,
    isSuppPlot ? suppTickFontSize : tickFontSize,
    4.5,
  )
  const [min, max] = x.range()
  return (
    <g>
      <line x1={min} y1={0} x2={max} y2={0} stroke={black_color} />
      <path d={`M${max - 8},5 L${max},0 L${max - 8},-5`} stroke={black_color} fill="none" />
      {label && (
        <g transform={`translate(${(max + min) / 2}, ${translate_factor})`}>
          <text fill={black_color} textAnchor="middle" fontFamily="Arial" fontSize={scaledFontSize}>
            {label}
          </text>
        </g>
      )}
      {formatter &&
        x.ticks().map((time, i) => (
          <g key={i} transform={`translate(${x(time)}, 4)`}>
            <line x1={0} y1={-4} x2={0} y2={0} stroke={black_color} />
            <text
              x={-8}
              y={12}
              fontFamily="Arial"
              fontSize={scaledTickSize}
              fill={black_color}
              stroke="none"
              textAnchor="end"
              transform="rotate(-60)"
            >
              {formatter(time)}
            </text>
          </g>
        ))}

      {/* Vertical Gridlines */}
      {gridlines && (
        <>
          {/* Make sure we have a gridline across the left/right edges of the plot by adding 0 and width to array */}
          {[...x.ticks(), 0, width].map((time, i) => (
            <g key={i} transform={`translate(${x(time)}, 0)`}>
              <line x1={0} y1={0} x2={0} y2={-1 * height} stroke={grey_color} />
            </g>
          ))}
        </>
      )}
      {/* End Vertical Gridlines */}
    </g>
  )
}

export default withFontSizeConfig(XAxis)
